/**
 * Deterministically rotate through a list of prompts based on the current date,
 * so the same prompt shows all day but changes day-to-day.
 */
export function rotatePrompt(prompts, offset = 0) {
  if (!Array.isArray(prompts) || prompts.length === 0) return "";
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((now - start) / 86_400_000);
  return prompts[(dayOfYear + offset) % prompts.length];
}

/**
 * Format a scripture reference string like "Matthew 28:19-20 NKJV" into a
 * typeset attribution line like "— Matthew 28:19–20, NKJV".
 */
export function formatAttribution(ref) {
  if (!ref) return "";
  const translations = /\b(NKJV|NIV|ESV|KJV|NASB|CSB|MSG|NLT|NRSV|AMP|HCSB)\b/i;
  const m = ref.match(new RegExp(`^(.+?)\\s+${translations.source}$`, "i"));
  if (!m) return `— ${ref.replace(/-/g, "\u2013")}`;
  const main = m[1].replace(/-/g, "\u2013"); // en dash for verse ranges
  return `— ${main}, ${m[2].toUpperCase()}`;
}
